import { AttachingMethod, Attachment, AttachmentType } from '../../../../types';
import { assertExists } from '../../../../util/guards';
import { UploadFileResponse } from './types';

const createImageUrl = (path: string) => new URL(path, 'https://static.wixstatic.com').href;
const createVideoUrl = (path: string) => new URL(path, 'https://video.wixstatic.com').href;

export const mapUploadResponse = (file: UploadFileResponse, attachingMethod: AttachingMethod): Attachment => {
  if (file.media_type === 'picture') {
    return {
      type: AttachmentType.Image,
      name: file.original_file_name,
      width: file.width,
      height: file.height,
      size: file.file_size,
      url: createImageUrl(file.file_url),
      attachingMethod,
      mimeType: file.mime_type,
    };
  }

  const videoData = file.file_output.video[0];

  assertExists(videoData, 'file_output.video should be presented');

  return {
    type: AttachmentType.Video,
    name: file.original_file_name,
    size: file.file_size,
    width: videoData.width,
    height: videoData.height,
    duration: videoData.duration,
    format: videoData.format,
    url: createVideoUrl(videoData.url),
    iconUrl: createImageUrl(file.icon_url),
    attachingMethod,
    mimeType: file.mime_type,
  };
};
